import React from 'react'
import { useRouter } from 'next/router'
import { isBrowser, getDisplayName } from 'common'
import { UserContext } from '../contexts/UserContext'

const Hoc = (WrappedPage, isGuru = false, registerAsUser = null) => {
  const WithAuth = (props) => {
    const router = useRouter()
    const { loggedUser } = React.useContext(UserContext)
    if (isBrowser()) {
      if (loggedUser === null) {
        if (typeof window !== 'undefined') {
          const query = { redirectUrl: window.location.href }
          if (registerAsUser === true) query.isGuru = false
          router.replace({
            pathname: '/login',
            query
          })
          return <></>
        }
      } else if (isGuru && !loggedUser.is_guru) {
        if (typeof window !== 'undefined') {
          router.replace('/')
          return <></>
        }
      }
    }
    return <WrappedPage {...props} />
  }

  WithAuth.displayName = `withLoggedUser(${getDisplayName(WrappedPage)})`

  return WithAuth
}

export default Hoc
